export default __webpack_public_path__ + "static/media/filter_sections_blue.svg.ec864077.svg";